/* eslint-disable */

export const routeHistoryModule = {
  state: {
    history: [], // a stack of routes
    goingBackExplicit: false, // a flag used for the back button *within* the app
    routingAnimationException: false, // a flag indicating that an animation exempt component pair transition is taking place
    currentRotue: undefined, // gets initialized on app load and changed on every route change

    // these component pairs are ignored / not added to the history stack
    // also some of them can have their animations turned off
    ignoredRouteTransitions: [
      {
        x: 'SportsComponent',
        y: 'SportsCategoriesComponent',
        animation: false,
      },
      {
        x: 'MyBetsComponent',
        y: 'MyFavoritesComponent',
        animation: 'default',
      },
      {
        x: 'MyBetsComponent',
        y: 'BetslipComponent',
        animation: 'default',
      },
      {
        x: 'MyFavoritesComponent',
        y: 'BetslipComponent',
        animation: 'default',
      },
    ],
  },
  mutations: {
    /**
     * This mutation sets the flag for navigating back, announcing the action to the route listener
     */
    setGoingBackExplicit(state) {
      state.goingBackExplicit = true;
    },
    /**
     * This mutation is executed every time a route changes
     */
    writeRoute(state, payload) {
      if (APP_SETTINGS.snapToTopOnRouteChange) {
        // document.querySelector('.bto-sb-mb-container').scrollIntoView();
        window.scrollTo(0, 0);
      }
      state.currentRotue = payload.toRoute;
      const fromComponentName = payload.fromRoute.matched[0].components.default.name;
      const toComponentName = payload.toRoute.matched[0].components.default.name;

      /**
       * if navigating back - pop the last entry and clear the flag.
       * 2 types of back navigation: through the UI button and through the browser/hardware button
       */
      if (state.goingBackExplicit || (state.history.length > 0 && payload.toRoute.path === state.history[state.history.length - 1].path)) {
        state.history.pop();
        state.goingBackExplicit = false;
        return;
      }

      // ignore routing within same component === only write different paths
      if (fromComponentName !== toComponentName) {

        // when navigating TO home, clear history
        if (payload.toRoute.path === '/') {
          state.history = [];
          return;
        }

        // animation and routing exceptions between components
        for (let i = 0; i < state.ignoredRouteTransitions.length; i++) {
          let componentPair = state.ignoredRouteTransitions[i];

          if (
            (fromComponentName === componentPair.x && toComponentName === componentPair.y)
            ||
            (fromComponentName === componentPair.y && toComponentName === componentPair.x)
            ) {
              if (APP_SETTINGS.animationsEnabled && !componentPair.animation) {
                state.routingAnimationException = true;
              }
              return;
          }
        }

        // write to history
        state.history.push(payload.fromRoute);
      }
    },
    /**
     * This mutation is executed on animation end in components which are an exception to the routing rules
     */
    routeExceptionEnd(state) {
      state.routingAnimationException = false;
    },
    /**
     * Gets called on initial app load
     */
    initializeCurrentRoute(state, route) {
      state.currentRotue = route;
    },
  },
};
